import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import VueTextareaAutosize from "vue-textarea-autosize";
import firebase from "firebase/app";
import "firebase/firestore";

Vue.use(VueTextareaAutosize);
Vue.config.productionTip = false;

firebase.initializeApp({
  apiKey: "AIzaSyBU8p7iiepDeGynSi6htk7gP8BJX3JOp8o",
  authDomain: "calendar-app-vue-62b2d.firebaseapp.com",
  databaseURL: "https://calendar-app-vue-62b2d.firebaseio.com",
  projectId: "calendar-app-vue-62b2d",
  storageBucket: "calendar-app-vue-62b2d.appspot.com",
  messagingSenderId: "725018619517",
  appId: "1:725018619517:web:01cdbec36dfe329ac5cb14",
});

export const db = firebase.firestore();
new Vue({
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
